class ConfigSectorsUtils {
  static getTypesAllowedBySector(sector, intl) {
    const typesAllowed = [
      {
        label: intl.formatMessage({
          id: "configSectorsScene.types.capacity",
        }),
        value: "CAPACITY",
      },
    ];
    if (sector?.types?.includes("PARKANDFLOW")) {
      typesAllowed.push(
        ...[
          {
            label: intl.formatMessage({
              id: "configSectorsScene.types.cars",
            }),
            value: "CARS",
          },
          {
            label: intl.formatMessage({
              id: "configSectorsScene.types.spots",
            }),
            value: "SPOTS",
          },
        ]
      );
    }
    if (sector?.types.includes("PEDESTRIANANDFLOW")) {
      typesAllowed.push({
        label: intl.formatMessage({
          id: "configSectorsScene.types.pedestrian",
        }),
        value: "PEDESTRIANS",
      });
    }
    return typesAllowed;
  }

  static getDefaultTypeBySector(sector) {
    if (sector?.types?.includes("PARKANDFLOW")) {
      return "CARS";
    }
    return "PEDESTRIANS";
  }

  static getDefaultValueBySector(sector, data) {
    const defaultType = ConfigSectorsUtils.getDefaultTypeBySector(sector);
    return ConfigSectorsUtils.getValueFromType(defaultType, sector, data);
  }

  static getValueFromType(type, sector, data) {
    return data?.find((s) => s.id === sector.id)?.[type.toLocaleLowerCase()];
  }

  static filterAreasByMapConfig(areas, mapAreasConfig) {
    return areas.filter(
      (area) =>
        area?.type === "PEDESTRIANANDFLOW" ||
        mapAreasConfig?.find(
          (areaConfig) =>
            areaConfig?.area_id && areaConfig?.area_id === area?.id
        ) !== undefined
    );
  }
}

export default ConfigSectorsUtils;
